<template>
  <div :docInfo="basicInfo" is="docAndService"></div>
</template>
<script>
  import docAndService from '@/components/common/basicDocAndService.vue';
  export default {
    components: { docAndService },
    data() {
      return {
        basicInfo: {
          title: '基础文档',
          docId: null,
        }
      }
    },
    created() {
      this.$_setTitle('基础文档-开放平台');
      this.basicInfo.docId = this.$route.query.docId;
    },
    methods: {

    },
  }
</script>
<style lang="scss">

</style>